export default __webpack_public_path__ + "static/media/capstone.7f4c7257.png";